import { useDispatch, useSelector } from "react-redux";

import PaginationControl from "./PaginationControl";

import {
  setPage as setPageAction,
  setPageCount as setPageCountAction,
  setPageCountWithConstantQueriesForApiCallObject as setPageCountWithConstantQueriesForApiCallObjectAction,
  setPageCountWithQueriesForApiReducerName as setPageCountWithQueriesForApiReducerNameAction,
  setPageWithConstantQueriesForApiCallObject as setPageWithConstantQueriesForApiCallObjectAction,
  setPageWithQueriesForApiReducerName as setPageWithQueriesForApiReducerNameAction,
} from "../../actions/advancedListActions";
import { getStateWithStringPath } from "../../utils/stateUtils";

export default function createPaginationControl(storeKey, apiObject) {
  return function PaginationControlWrapper(props) {
    const dispatch = useDispatch();
    const advList = useSelector((state) =>
      getStateWithStringPath(state, storeKey),
    );
    const { page, count, total, sort } = advList;

    const onChange = (value) => {
      const parameters =
        sort && sort.cellKey && sort.orders
          ? [storeKey, apiObject, value, sort]
          : [storeKey, apiObject, value];
      if (apiObject && apiObject.constantQueriesForApiCallObject) {
        return dispatch(
          setPageCountWithConstantQueriesForApiCallObjectAction(...parameters),
        );
      }
      if (apiObject && apiObject.queriesForApiReducerName) {
        return dispatch(
          setPageCountWithQueriesForApiReducerNameAction(...parameters),
        );
      }
      return dispatch(setPageCountAction(storeKey, value));
    };

    const onNext = () => {
      const parameters =
        sort && sort.cellKey && sort.orders
          ? [storeKey, apiObject, page + 1, sort]
          : [storeKey, apiObject, page + 1];
      if (apiObject && apiObject.constantQueriesForApiCallObject) {
        return dispatch(
          setPageWithConstantQueriesForApiCallObjectAction(...parameters),
        );
      }
      if (apiObject && apiObject.queriesForApiReducerName) {
        return dispatch(
          setPageWithQueriesForApiReducerNameAction(...parameters),
        );
      }
      return dispatch(setPageAction(storeKey, page + 1));
    };

    const onPrevious = () => {
      const parameters =
        sort && sort.cellKey && sort.orders
          ? [storeKey, apiObject, page - 1, sort]
          : [storeKey, apiObject, page - 1];
      if (apiObject && apiObject.constantQueriesForApiCallObject) {
        return dispatch(
          setPageWithConstantQueriesForApiCallObjectAction(...parameters),
        );
      }
      if (apiObject && apiObject.queriesForApiReducerName) {
        return dispatch(
          setPageWithQueriesForApiReducerNameAction(...parameters),
        );
      }
      return dispatch(setPageAction(storeKey, apiObject, page - 1));
    };

    return (
      <PaginationControl
        {...props}
        page={page}
        count={count}
        total={total}
        sort={sort}
        onChange={onChange}
        onNext={onNext}
        onPrevious={onPrevious}
      />
    );
  };
}
